import { Bot, Building2, KeyRound, type LucideIcon, Mail, ScrollText, Smartphone, Users } from "lucide-react";
import { NavLink, Outlet } from "react-router";
import { PageHeader } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { useCan } from "../../layout/workspace-context";

export const card = "rounded-card bg-surface p-5 shadow-card lg:p-6 [&_h2]:m-0 [&_h2]:text-[17px]";
export const rowList = "m-0 list-none rounded-card bg-surface p-0 px-5 shadow-card";
export const row =
  "flex flex-wrap items-center justify-between gap-3 border-b border-border py-3 last:border-0";

/** Abas de Configurações; Auditoria só aparece para quem pode ler (owner/admin). */
export function SettingsLayout() {
  const canAudit = useCan("audit:read");
  const tabs: Array<{ to: string; label: string; Icon: LucideIcon; end?: boolean }> = [
    { to: "", label: "Workspace", Icon: Building2, end: true },
    { to: "members", label: "Membros", Icon: Users },
    { to: "api-keys", label: "Tokens de API", Icon: KeyRound },
    { to: "agents", label: "Agentes", Icon: Bot },
    { to: "email", label: "E-mails", Icon: Mail },
    { to: "devices", label: "Aparelhos", Icon: Smartphone },
    ...(canAudit ? [{ to: "audit", label: "Auditoria", Icon: ScrollText }] : []),
  ];
  return (
    <>
      <PageHeader title="Configurações" />
      <div className="flex flex-col gap-6 lg:flex-row lg:items-start lg:gap-8">
        {/* Celular: pílulas roláveis; desktop: menu lateral próprio da seção. */}
        <nav
          aria-label="Configurações"
          className="-mx-4 flex gap-2 overflow-x-auto px-4 pb-1 [scrollbar-width:none] lg:sticky lg:top-6 lg:mx-0 lg:w-56 lg:shrink-0 lg:flex-col lg:gap-1 lg:overflow-visible lg:p-0"
        >
          {tabs.map(({ to, label, Icon, end }) => (
            <NavLink
              key={label}
              to={to}
              end={end}
              className={({ isActive }) =>
                cn(
                  "flex min-h-10 shrink-0 items-center gap-2 whitespace-nowrap rounded-full px-3.5 text-sm font-medium transition-colors lg:min-h-11 lg:rounded-control",
                  isActive
                    ? "bg-accent-soft text-accent-soft-ink"
                    : "bg-surface text-muted hover:bg-surface-2 hover:text-ink lg:bg-transparent",
                )
              }
            >
              <Icon aria-hidden="true" className="size-4" />
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="flex min-w-0 max-w-3xl flex-1 flex-col gap-6">
          <Outlet />
        </div>
      </div>
    </>
  );
}
